import { services } from '@octadesk-tech/services'
import { getParameterHeaders } from './headers'

const getClient = () =>
  services.createClient('knowledgebase', {
    headers: getParameterHeaders(true)
  })

const creteFilter = lastDate => ({
  take: 8,
  propertySort: 'UpdatedBy.Date',
  sortDirection: 'desc',
  externalQueries: [
    {
      propertyName: 'Status',
      operator: 2,
      valueCompare: '2'
    }
  ],
  lastId: lastDate
})

export const filterArticles = lastDate =>
  getClient()
    .then(client => client.post('articles/filter', creteFilter(lastDate)))
    .then(res => res.data)

export const searchArticles = term =>
  getClient()
    .then(client => client.get(`articles/search/${term}`))
    .then(res => {
      return {
        articles: res.data,
        scroll: res.headers['scrollid'],
        total: parseInt(res.headers['total'])
      }
    })

export const scrollArticles = scrollId =>
  getClient()
    .then(client =>
      client.get('articles/scroll', {
        headers: Object.assign({ scrollId }, getParameterHeaders(true))
      })
    )
    .then(res => res.data)

export const recordArticle = url =>
  getClient()
    .then(client => client.get(`articles/read/${url}`))
    .then(res => res.data)
